<template>
  <div class="main">
    <div class="steps clearfix text-center">
      <a href="https://www.smartcurrencyexchange.com/" >
          <img src="/assets/img/logo.png" />
      </a>
        </div>
    <div class="container">
      <div class="signup-form wizard clearfix">
        <div class="steps clearfix text-center">
          <img src="/assets/img/icons8-upload-to-cloud-100.png" />
        </div>
        <div class="content clearfix">
            <Identity/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Identity from "@/components/steps/Identity.vue";
export default {
    name:"Kyc",
    components:{
        Identity
    }
}
</script>